// @flow
import { PRODUCT_PRICE_TICKET_CUSTOM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_PRICE_TICKET_CUSTOM } from 'Utils/request/requestDictionary';

type CMSProps = {
  resortId: string,
  getAQuoteCTA: string,
  getAQuoteURL: string,
  price: string,
  amount: string,
};
type GQLProps = {
  resort: Resort,
  config: {
    common: {
      comparator: {
        backToSearch: string,
      },
    },
  },
};

export type LineProps = CMSProps & GQLProps;

export const productPriceTicketCustomResolver = {
  name: PRODUCT_PRICE_TICKET_CUSTOM,
  resolve: (
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> => {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const productArgs = buildProductArgs(productId, urlParams);

    const query = `query {
      resort(${productArgs}) {
        name
        badgeIcon
        comfortLabel
        type
        destination {
          country
        }
      }
      config {
        common {
          comparator {
            backToSearch
          }
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_PRICE_TICKET_CUSTOM,
    });
  },
};
